import { useState } from 'react';

const BASE = '/spring';

const field = {
  width: '100%', padding: '9px 11px', border: '1px solid #ccc', borderRadius: 8,
  fontSize: 14, background: '#fafafa', boxSizing: 'border-box', outline: 'none',
};

export default function RegistrationPage() {
  const [form, setForm] = useState({
    userName: '', userId: '', password: '', email: '',
    address: '', contactnumber: '', role: '6', bstatus: 'ACTIVE',
  });
  const [msg,     setMsg]     = useState(null);   // {text, ok}
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  // Characters that break S3 folder-prefix filtering or S3 path structure
  const INVALID_CHARS = /[%_/ ]/;
  const INVALID_MSG   = 'Must not contain %, _, /, or spaces. Use letters, digits, hyphens, or dots only.';

  const usernameError = form.userName && INVALID_CHARS.test(form.userName) ? INVALID_MSG : '';
  const useridError   = form.userId   && INVALID_CHARS.test(form.userId)   ? INVALID_MSG : '';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!/^\d{10}$/.test(form.contactnumber)) {
      setMsg({ text: 'Contact number must be exactly 10 digits', ok: false }); return;
    }
    if (INVALID_CHARS.test(form.userName)) {
      setMsg({ text: 'User Name: ' + INVALID_MSG, ok: false }); return;
    }
    if (INVALID_CHARS.test(form.userId)) {
      setMsg({ text: 'Login ID: ' + INVALID_MSG, ok: false }); return;
    }
    setLoading(true); setMsg(null);
    try {
      const payload = {
        userId:        form.userId,
        userName:      form.userName,
        password:      form.password,
        email:         form.email,
        address:       form.address,
        contactnumber: form.contactnumber,
        role:          form.role,
        bstatus:       form.bstatus,
      };
      const fd = new FormData();
      fd.append('empRegistrationData', JSON.stringify(payload));
      const res = await fetch(`${BASE}/registeremployee/${Date.now()}`, {
        method: 'POST', credentials: 'include', body: new URLSearchParams(fd),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      const text = await res.text();
      if (res.ok && text === 'Employee registration successful') {
        setMsg({ text: 'Client registered successfully', ok: true });
        setForm({ userName: '', userId: '', password: '', email: '', address: '', contactnumber: '', role: '6', bstatus: 'ACTIVE' });
      } else if (res.status === 444) {
        setMsg({ text: 'Session expired — please log in again', ok: false });
        setTimeout(() => { window.location.href = `${BASE}/login`; }, 1500);
      } else {
        setMsg({ text: text || 'Registration failed', ok: false });
      }
    } catch (err) {
      setMsg({ text: err.message, ok: false });
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 520, margin: '0 auto', padding: '20px 12px 60px' }}>
      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,.08)', padding: 24 }}>
        <div style={{ textAlign: 'center', borderBottom: '2px solid #e0e0e0', paddingBottom: 12, marginBottom: 20, fontSize: 18, fontWeight: 900, color: '#0066CC' }}>
          Client Registration
        </div>

        {msg && (
          <div style={{ marginBottom: 16, padding: '10px 14px', borderRadius: 8, fontSize: 13, background: msg.ok ? '#f0fff4' : '#fff5f5', border: `1px solid ${msg.ok ? '#9ae6b4' : '#feb2b2'}`, color: msg.ok ? '#276749' : '#c53030', display: 'flex', justifyContent: 'space-between' }}>
            {msg.text}
            <button onClick={() => setMsg(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, marginLeft: 8 }}>✕</button>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr><th colSpan={2} style={{ background: '#0066CC', color: '#fff', padding: '11px 14px', textAlign: 'center', fontSize: 14 }}>Registration Details</th></tr>
            </thead>
            <tbody>
              {[
                { label: 'User Name',  id: 'userName', type: 'text',     req: true, hint: usernameError, helpText: 'Letters, digits, hyphens, dots only — becomes the S3 folder name' },
                { label: 'Login ID',   id: 'userId',   type: 'text',     req: true, hint: useridError,   helpText: 'Letters, digits, hyphens, dots only' },
                { label: 'Password',   id: 'password', type: 'password', req: true, hint: '',            helpText: '' },
                { label: 'Email ID',   id: 'email',    type: 'email',    req: true, hint: '',            helpText: '' },
              ].map(({ label, id, type, req, hint, helpText }) => (
                <tr key={id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 14px', fontWeight: 600, color: '#555', width: '38%', whiteSpace: 'nowrap' }}>{label}</td>
                  <td style={{ padding: '10px 14px' }}>
                    <input type={type} value={form[id]} required={req} autoComplete="off"
                      onChange={e => set(id, e.target.value)}
                      onFocus={e => e.target.style.borderColor = '#0066CC'}
                      onBlur={e => e.target.style.borderColor = hint ? '#e53e3e' : '#ccc'}
                      style={{ ...field, borderColor: hint ? '#e53e3e' : '#ccc' }} />
                    {hint && (
                      <div style={{ color: '#c53030', fontSize: 11, marginTop: 4, lineHeight: 1.4 }}>⚠ {hint}</div>
                    )}
                    {!hint && helpText && (
                      <div style={{ color: '#888', fontSize: 11, marginTop: 4 }}>{helpText}</div>
                    )}
                  </td>
                </tr>
              ))}
              <tr style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '10px 14px', fontWeight: 600, color: '#555' }}>Contact Address</td>
                <td style={{ padding: '10px 14px' }}>
                  <textarea value={form.address} required rows={3} onChange={e => set('address', e.target.value)}
                    style={{ ...field, resize: 'vertical', minHeight: 72 }} />
                </td>
              </tr>
              <tr style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '10px 14px', fontWeight: 600, color: '#555' }}>Contact Number</td>
                <td style={{ padding: '10px 14px' }}>
                  <input type="tel" value={form.contactnumber} required maxLength={10} placeholder="10-digit number"
                    onChange={e => set('contactnumber', e.target.value.replace(/\D/g, '').slice(0, 10))}
                    style={field} />
                </td>
              </tr>
              <tr style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '10px 14px', fontWeight: 600, color: '#555' }}>Role</td>
                <td style={{ padding: '10px 14px' }}>
                  <select value={form.role} required onChange={e => set('role', e.target.value)} style={field}>
                    <option value="">-- Select --</option>
                    <option value="6">CLIENT</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td style={{ padding: '10px 14px', fontWeight: 600, color: '#555' }}>Status</td>
                <td style={{ padding: '10px 14px' }}>
                  <select value={form.bstatus} required onChange={e => set('bstatus', e.target.value)} style={field}>
                    <option value="">-- Select --</option>
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="DISABLE">DISABLE</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>

          <button type="submit" disabled={loading}
            style={{ width: '100%', padding: 13, background: loading ? '#99b8d8' : '#0066CC', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', marginTop: 14 }}>
            {loading ? 'Registering…' : 'Register'}
          </button>
        </form>
      </div>
    </div>
  );
}
